// src/components/common/SocialShareButtons.js
import React from 'react';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaWhatsapp,
  FaEnvelope 
} from 'react-icons/fa'; // Importe les icônes
import './SocialShareButtons.css';

function SocialShareButtons({ url, title, excerpt = "" }) {
  // Assure-toi que l'URL est absolue pour certains services de partage
  const absoluteUrl = typeof window !== 'undefined' ? window.location.href : url;

  const platforms = [
    {
      name: "Facebook",
      Icon: FaFacebookF,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(absoluteUrl)}`,
      className: "facebook"
    },
    {
      name: "Twitter",
      Icon: FaTwitter,
      url: `https://twitter.com/intent/tweet?url=<span class="math-inline">\{encodeURIComponent\(absoluteUrl\)\}&text\=</span>{encodeURIComponent(title)}`,
      className: "twitter"
    },
    {
      name: "LinkedIn",
      Icon: FaLinkedinIn,
      url: `https://www.linkedin.com/shareArticle?mini=true&url=<span class="math-inline">\{encodeURIComponent\(absoluteUrl\)\}&title\=</span>{encodeURIComponent(title)}&summary=${encodeURIComponent(excerpt)}`,
      className: "linkedin"
    },
    {
      name: "WhatsApp",
      Icon: FaWhatsapp,
      url: `https://api.whatsapp.com/send?text=${encodeURIComponent(title + " " + absoluteUrl)}`,
      className: "whatsapp"
    },
    {
        name: "Email",
        Icon: FaEnvelope,
        url: `mailto:?subject=<span class="math-inline">\{encodeURIComponent\(title\)\}&body\=</span>{encodeURIComponent("J'ai trouvé cet article intéressant : " + absoluteUrl)}`,
        className: "email"
    }
  ];

  return (
    <div className="social-share-buttons-container">
      <span className="share-label">Partager :</span>
      {platforms.map(platform => (
        <a
          key={platform.name}
          href={platform.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`social-share-button ${platform.className}`}
          aria-label={`Partager sur ${platform.name}`}
          title={`Partager sur ${platform.name}`}
        >
          <platform.Icon />
        </a>
      ))}
    </div>
  );
}

export default SocialShareButtons;